import React, { useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Bell, Send, Trash2 } from "lucide-react";

export function NotificationBroadcast() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", message: "" });

  const load = useCallback(async () => { try { const { data } = await api.get("/notifications"); setItems(data); } catch (e) {} }, []);
  useEffect(() => { load(); }, [load]);

  const send = async () => {
    if (!form.title || !form.message) { toast.error("Judul & pesan wajib diisi"); return; }
    try { await api.post("/notifications", form); toast.success("Notifikasi terkirim ke semua member"); setForm({ title: "", message: "" }); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { try { await api.delete(`/notifications/${id}`); load(); } catch (e) {} };

  return (
    <div className="grid gap-4 lg:grid-cols-2" data-testid="notification-broadcast">
      <Card className="card-surface rounded-2xl p-5">
        <div className="mb-4 flex items-center gap-2 font-display text-lg font-bold text-neutral-900"><Bell className="text-crimson" size={18} /> Pesan Notifikasi</div>
        <p className="mb-4 text-xs text-muted-foreground">Kirim pesan ke semua member. Aplikasi member akan berbunyi <b className="text-gold">bel 2×</b> & menampilkan pesan.</p>
        <div className="space-y-3">
          <div><Label className="text-xs text-muted-foreground">Judul</Label><Input data-testid="notif-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="mis. Promo Akhir Pekan!" className="mt-1 bg-neutral-100 border-neutral-200" /></div>
          <div><Label className="text-xs text-muted-foreground">Pesan</Label><textarea data-testid="notif-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={4} placeholder="Tulis pesan untuk member..." className="mt-1 w-full rounded-md bg-neutral-100 border border-neutral-200 p-3 text-sm text-neutral-900" /></div>
          <Button data-testid="send-notif-btn" onClick={send} className="w-full bg-crimson font-bold hover:bg-red-500"><Send size={16} className="mr-1" /> Kirim ke Semua Member</Button>
        </div>
      </Card>
      <Card className="card-surface rounded-2xl p-5">
        <div className="mb-4 font-display text-lg font-bold text-neutral-900">Riwayat Terkirim ({items.length})</div>
        <div className="max-h-[420px] space-y-2 overflow-y-auto">
          {items.map((n) => (
            <div key={n.id} data-testid={`notif-row-${n.id}`} className="rounded-xl bg-neutral-100 p-3">
              <div className="flex items-start justify-between gap-2">
                <div className="font-bold text-neutral-900">{n.title}</div>
                <button data-testid={`del-notif-${n.id}`} onClick={() => del(n.id)} className="text-muted-foreground hover:text-crimson"><Trash2 size={15} /></button>
              </div>
              <p className="text-sm text-muted-foreground">{n.message}</p>
              <div className="mt-1 text-[11px] text-muted-foreground">{new Date(n.created_at).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
            </div>
          ))}
          {items.length === 0 && <p className="text-sm text-muted-foreground">Belum ada notifikasi terkirim.</p>}
        </div>
      </Card>
    </div>
  );
}
